import { useTranslation } from "react-i18next";

import { Avatar, Button, Header } from "@pentabd/ui";

import { DECISION_TYPE } from "@constants/workflow-decision-type";

import { getFilePreviewURL } from "@helpers/getFilePreviewURL";
import { checkChairmanOrComissioner } from "@helpers/checkChairmanOrComissioner";

const { FORWARD, APPROVED, REJECT } = DECISION_TYPE;

interface ResignationsHeaderType {
  openModal: (arg: string) => void;
  data: {
    employeeName: string;
    employeePosition: string;
    employeeImage: string | undefined;
  };
  showActionButton: boolean;
  isFinalState: boolean;
  positionId: number | string;
  isLoading?: boolean;
}

export const ResignationsHeader = ({
  openModal,
  data: { employeeName, employeePosition, employeeImage },
  showActionButton,
  isFinalState,
  positionId,
  isLoading,
}: ResignationsHeaderType) => {
  const { t } = useTranslation();

  const actionButtons = [
    // <Button
    //   key={1}
    //   size="sm"
    //   fill={isFinalState ? "fill" : "outline"}
    //   type="primary"
    //   onClick={() => openModal(isFinalState ? APPROVED : FORWARD)}
    // >
    //   {t(
    //     `RESIGNATION.FORM.ACTION_BUTTONS.${
    //       isFinalState ? "APPROVE_BUTTON" : "FORWARD_BUTTON"
    //     }`
    //   )}
    // </Button>,
    isFinalState ? (
      <></>
    ) : !checkChairmanOrComissioner(positionId) ? (
      <Button
        key={1}
        size="sm"
        fill="outline"
        type="primary"
        onClick={() => openModal(FORWARD)}
        loading={isLoading}
      >
        {t("RESIGNATION.FORM.ACTION_BUTTONS.FORWARD_BUTTON")}
      </Button>
    ) : (
      <></>
    ),
    <Button
      key={2}
      size="sm"
      fill="fill"
      type="primary"
      onClick={() => openModal(APPROVED)}
      loading={isLoading}
    >
      {t("RESIGNATION.FORM.ACTION_BUTTONS.APPROVE_BUTTON")}
    </Button>,
    <Button
      key={3}
      size="sm"
      fill="fill"
      type="danger"
      onClick={() => openModal(REJECT)}
      loading={isLoading}
    >
      {t("RESIGNATION.FORM.ACTION_BUTTONS.REJECT_BUTTON")}
    </Button>,
  ];

  return (
    <div className="sticky-body bg-white">
      <Header
        size="sm"
        headerText={{
          header: employeeName,
          subHeader: employeePosition,
        }}
        avatar={
          <Avatar size="xm" name={employeeName} imageURL={employeeImage} />
        }
        className="px-9 py-8"
        actions={showActionButton ? actionButtons : undefined}
      />
    </div>
  );
};
